import React from 'react';
import { useLoad } from '../../collection/Hooks';
import { BsFormControl, BsFormSelect } from '../../collection/bootstrap/BootstrapComponents';
import BsModalForm from '../../collection/bootstrap/BsModalForm';
import { apiForm, apiGet } from '../../utils/api';
import Loading from '../../collection/icons/Loading';

export default function BajaModal(props) {
    const isNew = props.idBaja < 1;

    const updateData = async () => await apiGet("bajas/get/" + props.idBaja);

    const checkData = formData => {
        let errors = {};
        // Fecha inicio
        const fechaInicio = formData.get("fechaInicio");
        if (!fechaInicio) {
            errors["fechaInicio"] = "Campo obligatorio";
        }
        // Fecha fin
        const fechaFin = formData.get("fechaFin");
        if (!fechaFin) {
            errors["fechaFin"] = "Campo obligatorio";
        }
        // Trabajador
        if (props.super)
        {
            const trabajador = formData.get("trabajador");
            if (!trabajador) {
                errors["trabajador"] = "Campo obligatorio";
            }
        }
        return errors;
    }

    const saveData = async data => {
        const action = isNew ? "new" : "edit";
        const result = await apiForm("bajas/" + action, data);
        if (result) {
            props.onHide();
        }
    }

    return (
        <BsModalForm
            isNew={isNew}
            onUpdate={updateData}
            onCheck={checkData}
            onSave={saveData}
            modalTitle={isNew ? "Nueva baja" : "Editar baja"}
            show={props.show}
            onHide={props.onHide}
            saveOnEnter>
            {props.super ? <BajaFormSuper permisoAdmin={props.permisoAdmin} /> : <BajaForm />}
        </BsModalForm>
    );
}

function BajaForm(props) {
    const data = props.data;
    const errors = props.errors;
    return <>
        <BsFormControl
            /* Fecha inicio */
            label="Inicio" name="fechaInicio"
            value={data.fechaInicio} error={errors.fechaInicio}
            type="date" />
        <BsFormControl
            /* Fecha fin */
            label="Final" name="fechaFin"
            value={data.fechaFin} error={errors.fechaFin}
            className="mt-3" type="date" />
        <BsFormControl
            /* Justificante */
            label="Justificante" name="justificante"
            value=""
            className="mt-3" type="file" />
        <BsFormControl
            /* Comentario */
            label="Comentario" name="comentario"
            value={data.comentario} error={errors.comentario}
            className="mt-3" maxLength="250" as="textarea" />
    </>
}

function BajaFormSuper(props) {
    const data = props.data;
    const errors = props.errors;
    const [userList, reload] = useLoad(async () => { return await apiGet(props.permisoAdmin ? "usuarios/list" : "usuarios/listtrabajadores") });

    return userList ? <>
        <BsFormSelect
            /* Trabajador */
            label="Trabajador" name="trabajador"
            value={data.trabajador} error={errors.trabajador}
            options={userList} />
        <BsFormControl
            /* Fecha inicio */
            label="Inicio" name="fechaInicio"
            value={data.fechaInicio} error={errors.fechaInicio}
            className="mt-3" type="date" />
        <BsFormControl
            /* Fecha fin */
            label="Final" name="fechaFin"
            value={data.fechaFin} error={errors.fechaFin}
            className="mt-3" type="date" />
        <BsFormControl
            /* Justificante */
            label="Justificante" name="justificante"
            value=""
            className="mt-3" type="file" />
        <BsFormControl
            /* Comentario */
            label="Comentario" name="comentario"
            value={data.comentario} error={errors.comentario}
            className="mt-3" maxLength="250" as="textarea" />
    </> : <Loading />;
}
